import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  userName: string = '';
  userCompany: string = '';
  private userSub!: Subscription;

  constructor(
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userSub = this.authService.onUserChange().subscribe(data => {
      if (data) {
        this.userName = data.user?.name || data.name || '';
        this.userCompany = data.empresa?.nome || 'Colaborador';
      } else {
        this.userName = '';
        this.userCompany = '';
      }
      this.cdr.detectChanges();
    });

    if (this.authService.isLoggedIn() && !this.userName) {
      this.authService.getUserInfo().subscribe({
        next: (data) => {
          this.authService.notifyLogin(data);
        },
        error: () => {
          this.userName = '';
          this.userCompany = '';
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

  onLogout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/auth/login']);
      },
      error: () => {
        localStorage.removeItem('os_token');
        localStorage.removeItem('os_user');
        this.authService.notifyLogin(null);
        this.router.navigate(['/auth/login']);
      }
    });
  }
}